import { cn } from "@/lib/utils";

interface ContentSpinnerProps {
	className?: string;
}

/**
 * Spinner component for content loading states.
 * WARNING: DO NOT USE LOADINGSPINNER, IT WILL DISRUPT THE PODCAST PLAYBACK AND RESET ITS STATE.
 * Unlike LoadingSpinner, this component is not fixed/full-screen
 * and is designed to sit inside layout containers.
 */
export function ContentSpinner({ className }: ContentSpinnerProps) {
	return (
		<div
			className={cn(
				"flex h-full w-full min-h-[50vh] flex-1 items-center justify-center",
				className,
			)}
		>
			<img
				src="/podhive-icon.svg"
				alt="Loading content"
				className="h-20 w-20 animate-bounce motion-reduce:animate-none"
				draggable={false}
			/>
		</div>
	);
}
